import { _ as r } from "./index742.mjs";
import { r as o } from "./index745.mjs";
var t = r, e = o;
t({ target: "RegExp", proto: !0, forced: /./.exec !== e }, {
  exec: e
});
